<template>
  <div>
    <div
      v-if="!access"
      class="timelog-block-layout"
    >
      <div class="container">
        <div class="title-wrapper">
          <div class="main-title">
            {{ locales('timelog_access_title') }}
          </div>
          <div class="pricing-title-container">
            {{ planTitle }}
          </div>
        </div>
        <div class="desc">
          <div class="desc-text">
            {{ locales('timelog_access_desc') }}
            <div class="learn_more">
              <a
                class="pricing-popup-link"
                :href="locales('timelog_learn_more')"
                target="_blank"
                @click="linkClick"
              >{{ locales('help_read_more') }}</a>
              <webix-ui
                class="arrow-left"
                :config="icons.arrowLeft"
              />
            </div>
          </div>
        </div>
        <upgrade-btn v-if="isOwner"
                     :feature="'time_tracking'"/>
        <div class="pic">
          <img
            :src="pic"
            alt=""
          >
        </div>
      </div>
    </div>
    <webix-ui
      v-else
      :config="webixUI"
    />
    <router-view />
  </div>
</template>

<script>
import { webixUI, init, filterTableData } from './userLogs';
import pricingHelper from '../../helpers/pricingHelper';

import upgradeBtn from '../common/VueComponents/ugradeButton/upgradeButton.vue';
import svgIconForVue from "../common/svgIconForVue";
import arrowLeft from "../../svg/pricing/ic_arrow_left.svg";
import rights from '../../components/rights/index';
import globalStore from '$$globalStore';

export default {
  name: 'Reports',
  components: {
    upgradeBtn,
  },
  data() {
    return {
      locales: __,
      pic: `${GT.cdn}/imgs/myTimeLog/im_time_log.png`,
      icons: {
        arrowLeft: svgIconForVue(arrowLeft, 27, 16),
      },
    };
  },
  computed: {
    access() {
      return pricingHelper.checkPricingAccess('time_tracking');
    },
    planTitle() {
      const planTitle = `${pricingHelper.getPlans('time_tracking')}`;
      return planTitle;
    },
    isOwner() {
      return rights.account.isOwner();
    },
    currentFilter() {
      return globalStore.getters['filter/currentFilter'];
    },
  },
  created() {
    this.webixUI = webixUI;
  },
  mounted() {
    const access = pricingHelper.checkPricingAccess('time_tracking');
    this.$nextTick(() => {
      if (access) {
        init();
      }
    });
  },
  methods: {
    linkClick() {
      userExtAnalytics.log('pricing_deadlock_learn_more_clicked', { type: 'time_tracking' });
    },
  },
  watch: {
    currentFilter(value) {
      filterTableData();
    },
  },
};
</script>

<style scoped src="./less/timeLog.less"></style>
